import React from 'react';
import styled from 'styled-components';
import { ResponsiveImgSource, ResponsivenessConfig } from './StyledResponsiveImg';

/* Types */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export type Interpolations = any[];

/* Helpers */
export const generateSrcSetString = (sources: ResponsiveImgSource[]): string => {
  const sourcesStrings: string[] = [];
  sources.forEach(({ src, width }) => {
    if (width) {
      sourcesStrings.push(`${src} ${width}w`);
    }
  });

  return sourcesStrings.join(', ');
};

export const generateSizesString = (responsiveConfig: ResponsivenessConfig): string => {
  const {
    fallbackSize: { width: fallbackSizeWidth },
    sizes,
  } = responsiveConfig;

  if (!sizes) {
    return fallbackSizeWidth;
  }

  const sizesStrings: string[] = [];
  sizes.forEach(({ mediaQuery, width }) => {
    if (width) {
      sizesStrings.push(`${mediaQuery ? `${mediaQuery} ` : ''}${width}`);
    }
  });
  sizesStrings.push(fallbackSizeWidth);

  return sizesStrings.join(', ');
};

/* eslint-disable-next-line prefer-arrow/prefer-arrow-functions */
export const createStyledImg = function<T extends object = {}>(
  props: React.ImgHTMLAttributes<HTMLImageElement>,
  templateStringsArray: TemplateStringsArray,
  interpolations: Interpolations,
): React.ReactNode {
  return React.createElement(styled.img<T>(templateStringsArray, ...interpolations), props as React.Attributes);
};
